// src/redux/settingsPages/security/securitySlice.js
import { createSlice } from '@reduxjs/toolkit';
import { setupMfaThunk, verifyMfaSetupThunk, disableMfaThunk } from './securityActions';

const initialState = {
  setupData: null,   // { qr_code, secret } -- pending setup, not yet verified
  loading: false,
  error: null,
  verifying: false,
  verifyError: null,
  disabling: false,
  disableError: null,
  lastAction: null,  // "setup-started" | "setup-verified" | "disabled"
};

const slice = createSlice({
  name: 'security',
  initialState,
  reducers: {
    clearMfaSetupData(state) {
      state.setupData = null;
    },
    clearSecurityErrors(state) {
      state.error = null;
      state.verifyError = null;
      state.disableError = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(setupMfaThunk.pending, (s) => { s.loading = true; s.error = null; })
      .addCase(setupMfaThunk.fulfilled, (s, a) => { s.loading = false; s.setupData = a.payload; s.lastAction = 'setup-started'; })
      .addCase(setupMfaThunk.rejected, (s, a) => { s.loading = false; s.error = a.payload; })

      .addCase(verifyMfaSetupThunk.pending, (s) => { s.verifying = true; s.verifyError = null; })
      .addCase(verifyMfaSetupThunk.fulfilled, (s) => { s.verifying = false; s.setupData = null; s.lastAction = 'setup-verified'; })
      .addCase(verifyMfaSetupThunk.rejected, (s, a) => { s.verifying = false; s.verifyError = a.payload; })

      .addCase(disableMfaThunk.pending, (s) => { s.disabling = true; s.disableError = null; })
      .addCase(disableMfaThunk.fulfilled, (s) => { s.disabling = false; s.lastAction = 'disabled'; })
      .addCase(disableMfaThunk.rejected, (s, a) => { s.disabling = false; s.disableError = a.payload; });
  },
});

export const { clearMfaSetupData, clearSecurityErrors } = slice.actions;
export default slice.reducer;
